import { FILE_TOO_LARGE } from 'constants/errors'
import React from 'react'

import { Modal } from 'widgets/Modal'
import { Text } from 'widgets/Text'

interface Props {
  isVisible: boolean
  onClose: () => void
}

export const FileSizeErrorModal = ({ isVisible, onClose }: Props): JSX.Element => (
  <Modal
    actionButtonProps={[{ onPress: onClose, type: 'grey', title: 'Close' }]}
    isVisible={isVisible}
    onClose={onClose}
    title='Invalid file size'
  >
    <Text align='center'>{FILE_TOO_LARGE.message}</Text>
  </Modal>
)
